import {
  CREATE_RESULT,
  CREATE_RESULT_SUCCESS,
  CREATE_RESULT_FAILURE,
  UPDATE_RESULT,
  UPDATE_RESULT_SUCCESS,
  UPDATE_RESULT_FAILURE,
  MARK_RESULT,
  MARK_RESULT_SUCCESS,
  MARK_RESULT_FAILURE,
  GET_RESULT_BY_TEST_ID,
  GET_RESULT_BY_TEST_ID_SUCCESS,
  GET_RESULT_BY_TEST_ID_FAILURE,
  GET_RESULTS_COUNT,
  GET_RESULTS_COUNT_SUCCESS,
  GET_RESULTS_COUNT_FAILURE,
  FETCH_RESULTS_BY_CANDIDATE_ID,
  FETCH_RESULTS_BY_CANDIDATE_ID_SUCCESS,
  FETCH_RESULTS_BY_CANDIDATE_ID_FAILURE,
} from "./actionTypes";

// Create Result
export const createResult = (result) => ({
  type: CREATE_RESULT,
  payload: result,
});

export const createResultSuccess = (result) => ({
  type: CREATE_RESULT_SUCCESS,
  payload: result,
});

export const createResultFailure = (error) => ({
  type: CREATE_RESULT_FAILURE,
  payload: error,
});

// Update Result
export const updateResult = (result) => ({
  type: UPDATE_RESULT,
  payload: result,
});

export const updateResultSuccess = (result) => ({
  type: UPDATE_RESULT_SUCCESS,
  payload: result,
});

export const updateResultFailure = (error) => ({
  type: UPDATE_RESULT_FAILURE,
  payload: error,
});

// Mark Result
export const markResult = (result) => ({
  type: MARK_RESULT,
  payload: result,
});

export const markResultSuccess = (result) => ({
  type: MARK_RESULT_SUCCESS,
  payload: result,
});

export const markResultFailure = (error) => ({
  type: MARK_RESULT_FAILURE,
  payload: error,
});

// Get Result by id
export const getResultByTestId = (result) => ({
  type: GET_RESULT_BY_TEST_ID,
  payload: result,
});

export const getResultByTestIdSuccess = (result) => ({
  type: GET_RESULT_BY_TEST_ID_SUCCESS,
  payload: result,
});

export const getResultByTestIdFailure = (error) => ({
  type: GET_RESULT_BY_TEST_ID_FAILURE,
  payload: error,
});

// Get all results
export const getResultsCount = (count) => ({
  type: GET_RESULTS_COUNT,
  payload: count,
});

export const getResultsCountSuccess = (count) => ({
  type: GET_RESULTS_COUNT_SUCCESS,
  payload: count,
});

export const getResultsCountFailure = (error) => ({
  type: GET_RESULTS_COUNT_FAILURE,
  payload: error,
});

// Fetch Results By Candidate ID
export const fetchResultsByCandidateId = (candidateId) => ({
  type: FETCH_RESULTS_BY_CANDIDATE_ID,
  payload: candidateId,
});

export const fetchResultsByCandidateIdSuccess = (results) => ({
  type: FETCH_RESULTS_BY_CANDIDATE_ID_SUCCESS,
  payload: results,
});

export const fetchResultsByCandidateIdFailure = (error) => ({
  type: FETCH_RESULTS_BY_CANDIDATE_ID_FAILURE,
  payload: error,
});
